export const vehicleHistoryStyles = (theme) => {
  const desktop = theme.breakpoints.up("md");
  const mobile = theme.breakpoints.down("sm");
  return {
    badges: {
      position: "absoolute",
      right: 0,
      top: 0,
      display: "flex",
      background: "transparent",
      overflow: "hidden",
      width: 200,
      flexDirection: "row-reverse",
      [mobile]: {
        display: "none",
      },
    },
    date: {
      backgroundColor: theme.palette.primary.dark,
      height: 40,
      paddingLeft: 20,
      display: "flex",
      alignItems: "center",
      textTransform: "uppercase",
      position: "sticky",
      top: 0,
      zIndex: 4,
    },
    dataField: {
      display: "flex",
      alignItems: "flex-start",
      [mobile]: {
        width: 100,
      },
    },
    smallDataField: {
      [desktop]: {
        width: 100,
      },
    },
    detailsContainer: {
      marginTop: 30,
      display: "flex",
      height: 750,
      [mobile]: {
        flexDirection: "column-reverse",
        justifyContent: "start",
        height: 500,
      },
    },
    eventDescription: {
      width: 225,
    },
    eventHeaderRow: {
      display: "flex",
      alignItems: "center",
      width: "100%",
      [mobile]: {
        marginLeft: 0,
      },
    },
    eventIcon: {
      position: "absolute",
      left: 30,
      width: 20,
      height: 20,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      [desktop]: {
        left: 30,
      },
    },
    eventDetails: {
      display: "flex",
      flexDirection: "column",
      textTransform: "capitalize",
      [desktop]: {
        marginLeft: 40,
      },
    },
    eventType: {
      [mobile]: {
        paddingLeft: 40,
      },
    },
    Accordion: {
      boxShadow: "none",
      borderBottom: "1px solid #111",
      backgroundColor: theme.palette.background.timeline,
      padding: 0,
    },
    AccordionContents: {
      padding: "0 0 0 2px",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
      [mobile]: {
        paddingLeft: 20,
        width: "calc(100% - 20px)",
      },
    },
    headerStats: {
      [mobile]: {
        marginRight: 75,
      },
    },
    iconButton: {
      [mobile]: {
        position: "absolute",
        right: 30,
      },
    },
    innerWrapper: {
      display: "flex",
      alignItems: "center",
      width: "100%",
    },
    mapContainer: {
      [mobile]: {
        width: "100%",
      },
      [desktop]: {
        width: "34%",
      },
    },
    myLocation: {
      position: "absolute",
      color: theme.palette.text.blue,
      background: theme.palette.background.dark,
      right: 10,
      padding: 2,
      [mobile]: {
        right: 26,
      },
    },
    root: {
      width: "100%",
    },
    summaryKeys: {
      display: "inline-flex",
      [desktop]: {
        width: 300,
      },
      [mobile]: {
        alignSelf: "flex-start",
        textAlign: "right",
        width: 100,
      },
    },
    summaryRoot: {
      background: theme.palette.background.selected,
      padding: "20px 0 20px 0",
      width: "100%",
      borderTop: `1px solid ${theme.palette.primary.divider}`,
      borderBottom: "1px solid #333",
      [desktop]: {
        display: "flex",
        justifyContent: "flex-end",
      },
      [mobile]: {
        width: "calc(100% - 30px)",
        paddingLeft: 160,
      },
    },
    summaryWrapper: {
      [desktop]: {
        width: 382,
      },
      [mobile]: {
        display: "flex",
        flexDirection: "column",
        padding: "10px 40px",
      },
    },
    actionsWrapper: {
      [desktop]: {
        width: 382,
        display: "flex",
        justifyContent: "space-between",
      },
      [mobile]: {
        display: "flex",
        flexDirection: "column",
        padding: "10px 40px",
      },
    },
    stats: {
      display: "inline-flex",
      [desktop]: {
        width: 234,
      },
    },
    timelineHeader: {
      height: 48,
      paddingLeft: 22,
      borderTop: `1px solid ${theme.palette.primary.divider}`,
      [mobile]: {
        height: 60,
        paddingLeft: 6,
      },
    },
    timelineTripRoot: {
      padding: 0,
      width: "100%",
      display: "flex",
      [desktop]: {
        justifyContent: "flex-end",
      },
      [mobile]: {
        marginLeft: -20,
      },
    },
    timeLineRoot: {
      overflow: "hidden",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      [mobile]: {
        width: "100%",
        maxHeight: 240,
      },
      [desktop]: {
        width: "66%",
      },
    },
    timelineStatus: {
      [desktop]: {
        width: 182,
      },
      [mobile]: {
        width: 100,
        marginLeft: 10,
      },
    },
    timelineTripWrapper: {
      position: "relative",
      borderBottom: "1px solid #333",
      display: "flex",
      justifyContent: "space-between",
      padding: "16px 0 16px 30px",
      width: "100%",
      [desktop]: {
        width: "calc(100% - 60px)",
      },
      [mobile]: {
        flexDirection: "column",
      },
    },
    blueButton: {
      color: theme.palette.text.blue,
      border: "none",
      borderRadius: 4,
      textTransform: "uppercase",
      cursor: "pointer",
      margin: "30px 0 10px -8px",
      padding: 10,
      width: 75,
      background: "transparent",
      "&:hover": {
        background: theme.palette.background.selected,
      },
      [mobile]: {
        margin: "20px 0 0 -8px",
      },
    },
    emptyHistoryContainer: {
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    emptyHistory: {
      maxWidth: "75%",
      textAlign: "center",
    },
  };
};
